// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fxPsz","right":"styles_right__24sWy"};